import styled from 'styled-components';

/* $mirrored flips the panel so right-column controls sit against the center gutter */
export const ChecklistItemPanelContainer = styled.div`
    align-items: center;
    cursor: pointer;
    background: ${(props) =>
        props.$isCollected ? 'rgba(255, 255, 255, 0.20)' : 'rgba(255, 255, 255, 0.025)'};
    border: 1px solid var(--Widget-Border, rgba(255, 255, 255, 0.33));
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${(props) => props.$mirrored ? 'row-reverse' : 'row'};
    justify-content: space-between;
    min-width: 0;
    padding: ${(props) => props.$mirrored ? '8px 16px 8px 8px' : '8px 8px 8px 16px'};
    width: 50%;
`;
export const LeftContainer = styled.div`
    align-items: ${(props) => props.$mirrored ? 'flex-end' : 'flex-start'};
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    overflow: hidden;
`;
export const CardNumber = styled.h3`
    color: #D0D0D0;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
`;

export const DetailsContainer = styled.div`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-direction: ${(props) => props.$mirrored ? 'row-reverse' : 'row'};
    gap: 8px;
    min-width: 0;
`;

export const Name = styled.h4`
    color: #FFF;
    font-family: "Roboto Condensed";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    margin-left: ${(props) => props.$mirrored ? '12px' : '0'};
    margin-right: ${(props) => props.$mirrored ? '0' : '12px'};
    min-width: 0;
    overflow: hidden;
    text-align: ${(props) => props.$mirrored ? 'right' : 'left'};
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`;

/* Mirrored: chips run right-to-left from the card number, so overflow clips on the left */
export const TagsContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: ${(props) => props.$mirrored ? 'row-reverse' : 'row'};
    flex-wrap: nowrap;
    gap: 4px;
    min-height: 28px;
    min-width: 0;
    overflow: hidden;
`;

export const RightContainer = styled.div`
    align-items: end;
    align-self: stretch;
    display: flex;
    flex-direction: ${(props) => props.$mirrored ? 'row-reverse' : 'row'};
    flex-shrink: 0;
    gap: 8px;
    justify-content: center;
`;

/* Groups "- qty +" so mirroring reorders the control clusters without flipping the stepper */
export const QtyControlsGroup = styled.div`
    align-items: end;
    display: flex;
    flex-shrink: 0;
    gap: 8px;
`;

export const QtyBtn = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.20);
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.10);
    color: #FFFFFF;
    width: 24px;

    &:hover {
        background: rgba(255, 255, 255, 0.20);
        cursor: pointer;
    }
`;  

export const QtyInputWrapper = styled.div`
    cursor: pointer;
    display: block;
    flex-shrink: 0;
    user-select: none;

    &:focus {
        outline: none;
    }
`;

/* QtyInput - fieldset so the ADD/REMOVE legend breaks the top border, like InputBar/InputDropdown */
export const QtyInputContainer = styled.fieldset`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0;
    min-width: 80px;
    padding: 0;
    position: relative;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
    width: max-content;

    ${QtyInputWrapper}:hover & {
        background: rgba(255, 255, 255, 0.18);
        border-color: rgba(255, 255, 255, 0.4);
    }

    ${QtyInputWrapper}:active & {
        background: rgba(255, 255, 255, 0.06);
        border-color: rgba(255, 255, 255, 0.15);
        transform: scale(0.96);
    }
`;

/* Keeps the value row at the same height as InputBar/InputDropdown controls */
export const QtyInputField = styled.div`
    align-items: center;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 38px;
    justify-content: center;
    padding: 0 12px;
    position: relative;
`;

export const CustomInputsRow = styled.div`
    align-items: flex-end;
    display: flex;
    gap: 8px;
    min-width: 0;
`;

export const CustomInputWrapper = styled.div`
    min-width: 0;
    width: ${(props) => props.$width ?? 'auto'};
`;

/* In-flow legend — creates a real gap in the fieldset border. No float. */
export const QtyInputLabel = styled.legend`
    background: transparent;
    color: rgba(255, 255, 255, 0.65);
    display: block;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    margin: 0 auto;
    max-width: 100%;
    padding: 0 5px;
    white-space: nowrap;
    width: max-content;
`;
